import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, range } from 'util/validation'

import { AntropometriaAccordionModel } from './AntropometriaAccordion'
import { validateForcaMuscularMao, validateForcaMuscularMaoRange } from './validator-forcaMuscularMao'

const path = metaPath<AntropometriaAccordionModel>()

export const antropometriaValidator = createValidator<AntropometriaAccordionModel>(
  {
    peso: [maxLength(7), range(0.5, 500)],
    altura: [maxLength(5), range(20, 250)],
    perimetroCefalico: [maxLength(5), range(10, 200)],
    circunferenciaAbdominal: [maxLength(6)],
    perimetroPanturrilha: [maxLength(5), range(10, 99)],
    valorForcaMuscMaoDireita: [validateForcaMuscularMaoRange],
    valorForcaMuscMaoEsquerda: [validateForcaMuscularMaoRange],
    pele: [maxLength(300)],
    olhoDireito: [maxLength(250)],
    olhoEsquerdo: [maxLength(250)],
    ouvidoDireito: [maxLength(250)],
    ouvidoEsquerdo: [maxLength(250)],
    membroInferiorDireito: [maxLength(250)],
    membroInferiorEsquerdo: [maxLength(250)],
  },
  (values, errors) => {
    validateForcaMuscularMao(values, errors, path.valorForcaMuscMaoDireita, path.unidadeForcaMuscMaoDireita)
    validateForcaMuscularMao(values, errors, path.valorForcaMuscMaoEsquerda, path.unidadeForcaMuscMaoEsquerda)

    return errors
  }
)
